import { useCallback, useEffect, useState, useRef } from 'react'
import Table from "../Components/Table/Table";
import { Link } from "react-router-dom";
import { Api } from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Popup from "../Components/PopUp/Popup";
import SearchUI from '../Search/SearchUI';
import ExportMetaData from '../Main/ExportMetaData/ExportMetaData'
import DeleteModal from '../Components/Deletemodal/DeleteModal';

const Reportconfig = {
    url: "certificates",
    name: "Report",
    columns: [
        {
            name: "Name", accessor: (object) => {
                if (object?.template?.name) {
                    return object?.template?.name
                }
                else {
                    return <spam style={{ color: "red" }}>Event Deleted</spam>;
                }
            }
        },
        {
            name: "Type", accessor: (object) => {
                return object.eventWith;
            }
        },
        {
            name: "Download", accessor: (object) => {
                if (object["eventWith"] == "IIC") {
                    let links = `/iicreport/${object.id}`;
                    if (object.newIic) {
                        links = `/newIicReport/${object.id}`;
                    }
                    return <Link to={links} >Download Report</Link>;
                }
                else if (object["eventWith"] == "RISE-Event") {
                    let links = `/riseEventReport/${object.id}`;
                    return <Link to={links} >Download Report</Link>;
                }
                else {
                    let links = `/eventreport/${object.id}`;
                    return <Link to={links} >Download Report</Link>;
                }

            }
        },
        // { name: "Actions", key: "actions" },
    ]
}

const RoleWiseReport = ({ user, ...props }) => {
    const params = useParams();
    const { id } = params;
    let tableRef = new Table();
    const navigate = useNavigate();
    const [del, setDel] = useState(false);

    const config = Reportconfig;
    const [state, setState] = useState({
        loading: false,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 0,
        show: false,
        search: true,
        showSearch: false
    });

    const [filter, setFilter] = useState(null);
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(-1);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");

    useEffect(() => {
        Api.call('/departmentNameWithId').then(res => {
            setDepartments(res);
        }).catch(err => console.log("Error fetching departments:", err));
    }, []);

    const loadData = useCallback(() => {
        let start = 0;
        const limit = state.limit;
        const page = state.page;
        start = (page - 1) * limit;

        let query = `?_limit=${limit}&_start=${start}`;
        let countQuery = "";

        const addFilter = (key, value) => {
            if (value) {
                query += `&${key}=${value}`;
                countQuery += (countQuery === "" ? "?" : "&") + `${key}=${value}`;
            }
        };

        if (startDate) addFilter('template.start_date_gte', startDate);
        if (endDate) addFilter('template.start_date_lte', endDate);
        if (selectedDepartment) addFilter('template.department', selectedDepartment);

        Api.call(`/getReportRoleWiseCount${countQuery}`).then((data) => {
            setTotal(data);
        }).catch((e) => {
            console.log(e);
        }).finally(() => {
            setState(s => ({ ...s, loading: false }))
        })

        Api.call(`/getReportbyRole${query}`)
            .then((data) => {
                setPosts(data);
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                setState(s => ({ ...s, loading: false }))
            })
    }, [state.page, state.limit, startDate, endDate, selectedDepartment]);

    const onPaginate = (page) => {
        setState({ ...state, page: page, loading: true })
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        loadData()
    }, [loadData, params.path, user, params.id]);

    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            <td key={index}>{`${(state.page - 1) * state.limit + (index + 1)}`}</td>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({ ...state, row: row, allSelected: allSelected });
    };

    const onDelete = (event, index) => {
        setState(s => {
            return { ...s, loading: true }
        });
        event.preventDefault();
        let post = posts[index];
        setDel(false);
        Api.call(`/${config.url}/${post.id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({ ...state, loading: true })
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };


    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        // if (index === row.length - 1) {

        //     if (state.config.renderActions) {
        //         return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp , onDown,onDelete, state, config);
        //     }
        //     else {
        //         return <td key={index}>
        //         <ul>
        //             <li>                          
        //                 <Link to={`/Report/${originalRow.id}/${params.id}`}>
        //                 {columnConfig.editIcon}
        //                 </Link>
        //             </li>
        //         </ul>
        //     </td>
        // }
        // }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{ color: column ? "green" : "red" }}>{column ? "Yes" : "No"}</span></td>
        }
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };

    // if(state.loading === false && posts.length === 0)
    // {
    //     return (
    //         <div className="right_container">
    //             <div className="dashboard">
    //                 <div className='inner-content'>
    //                     <div className="heading-for-certificate">
    //                         <h2>{`Events`}</h2>
    //                         <p>
    //                             There are no events created yet.
    //                             Start adding events by clicking on add new event. 
    //                         </p>
    //                         <ul>

    //                             <li>
    //                                 <Link to={`/${config.url}/new`}>
    //                                     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
    //                                     Add New
    //                                 </Link>
    //                             </li> 
    //                         </ul>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }
    return (
        <div className="right_container">
            <Popup trigger={del} icon='../../../../images/delete-icon.svg' actionParams={id} action={onDelete} class="delete-popup" setSearch={setDel}>
                <DeleteModal />
            </Popup>
            <div className="dashboard">
                <div className='inner-content'>

                    <Heading name={config.name} refreshlink="#" url={params.path} total={total}
                        certificate={params.id} navigate={navigate} />

                    <div className="filter-section" style={{
                        display: 'flex',
                        gap: '20px',
                        marginBottom: '25px',
                        marginTop: '10px',
                        padding: '20px',
                        background: '#ffffff',
                        borderRadius: '15px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                        alignItems: 'flex-end',
                        flexWrap: 'wrap'
                    }}>
                        <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '13px', fontWeight: '600', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Department</label>
                            <select
                                value={selectedDepartment}
                                onChange={(e) => {
                                    setSelectedDepartment(e.target.value);
                                    setState(s => ({ ...s, page: 1, loading: true }));
                                }}
                                style={{
                                    padding: '12px 15px',
                                    borderRadius: '10px',
                                    border: '1px solid #e0e0e0',
                                    outline: 'none',
                                    fontSize: '14px',
                                    color: '#333',
                                    width: '200px',
                                    transition: 'border-color 0.3s ease',
                                    backgroundColor: '#f9f9f9',
                                    appearance: 'none',
                                    backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M10.293%203.293L6%207.586%201.707%203.293A1%201%200%2000.293%204.707l5%205a1%201%200%20001.414%200l5-5a1%201%200%2010-1.414-1.414z%22%2F%3E%3C%2Fsvg%3E")',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right 15px center'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                            >
                                <option value="">All Departments</option>
                                {departments.map(dept => (
                                    <option key={dept.Id} value={dept.Id}>{dept.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '13px', fontWeight: '600', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>From Date</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                    setState(s => ({ ...s, page: 1, loading: true }));
                                }}
                                style={{
                                    padding: '12px 15px',
                                    borderRadius: '10px',
                                    border: '1px solid #e0e0e0',
                                    outline: 'none',
                                    fontSize: '14px',
                                    color: '#333',
                                    width: '200px',
                                    transition: 'border-color 0.3s ease',
                                    backgroundColor: '#f9f9f9'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                            />
                        </div>
                        <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '13px', fontWeight: '600', color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px' }}>To Date</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => {
                                    setEndDate(e.target.value);
                                    setState(s => ({ ...s, page: 1, loading: true }));
                                }}
                                style={{
                                    padding: '12px 15px',
                                    borderRadius: '10px',
                                    border: '1px solid #e0e0e0',
                                    outline: 'none',
                                    fontSize: '14px',
                                    color: '#333',
                                    width: '200px',
                                    transition: 'border-color 0.3s ease',
                                    backgroundColor: '#f9f9f9'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                            />
                        </div>
                        <button
                            onClick={() => {
                                setStartDate("");
                                setEndDate("");
                                setSelectedDepartment("");
                                setState(s => ({ ...s, page: 1, loading: true }));
                            }}
                            style={{
                                padding: '12px 25px',
                                borderRadius: '10px',
                                border: 'none',
                                backgroundColor: '#f0f2f5',
                                color: '#555',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                height: '45px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e4e6e9'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f0f2f5'}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>
                            Reset
                        </button>
                    </div>

                    <div className='commen-table'>
                        <Table serial={true} ref={tableRef} renderColumn={renderColumn} loading={state.loading}
                            renderRow={renderRow} renderHeaderColumn={renderHeaderColumn}
                            columns={state.config.columns} cardFooter="cardFooter" total={total}
                            currentPage={state.page} perPage={state.limit} filter={localStorage.getItem("data") ? { "query": true } : filter}
                            rows={posts} selected="Invite Selected" onPaginate={onPaginate}
                            onChangePerPage={(limit) => {
                                setState({ ...state, limit });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleWiseReport)
